



















import request from '@/graphql/request';
import { Component, Prop, Vue } from 'vue-property-decorator';

// We manually define these types as the vue types will not properly import
interface IDictionary<T> {
  [key: string]: T;
}
interface IVueLocation {
  name?: string;
  path?: string;
  hash?: string;
  query?: IDictionary<string>;
  params?: IDictionary<string>;
  append?: boolean;
  replace?: boolean;
}

@Component({})
export default class RedirectModal extends Vue {
  @Prop({ required: true })
  public title!: string;
  @Prop({ required: true })
  public confirmationText!: string;
  @Prop({ required: true })
  public visible!: boolean;
  @Prop({ required: true })
  public to!: IVueLocation;

  public confirm() {
    this.$emit('modalRedirect');
  }
}
